module.exports = __webpack_public_path__ + "static/img/acn03.6557a0d1.png";